// formatApiErrorDetail e campoErrore di frontend/src/lib/api.js (31a5bd1): il testo dell'errore di una risposta /api
// (detail stringa, errori pydantic in elenco, oggetto con msg). Senza dettaglio il testo generico.
const CAMPI_ERRORE = { telefono: "Telefono", pec: "PEC", email_impresa: "Email dell'impresa", denominazione: "Denominazione",
  codice_fiscale: "Codice fiscale", partita_iva: "Partita IVA", indirizzo: "Indirizzo", civico: "Civico", cap: "CAP",
  provincia: "Provincia", rea: "Numero REA", nome: "Nome", cognome: "Cognome", ruolo: "Ruolo", luogo_nascita: "Luogo di nascita",
  data_nascita: "Data di nascita", importo: "Importo", nota: "Nota", addetti: "Addetti", data_costituzione: "Data di costituzione" }

function campoErrore(e) {
  const loc = (e.loc || []).filter((x) => typeof x === "string" && x !== "body")
  const k = loc[loc.length - 1]
  const nome = CAMPI_ERRORE[k] || k || ""
  const motivo = e.type === "string_too_long" ? `troppo lungo (massimo ${e.ctx?.max_length} caratteri)`
    : e.type === "missing" ? "obbligatorio"
      : /^(int|float|decimal)_/.test(e.type || "") ? "deve essere un numero" : e.msg
  return nome ? `${nome}: ${motivo}.` : e.msg
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova."
  if (typeof detail === "string") return detail
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? campoErrore(e) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ")
  }
  if (detail && typeof detail.msg === "string") return detail.msg
  return String(detail)
}

// Una richiesta /api come axios dell'originale: JSON (o FormData) con la sessione e il token CSRF. Risolve con il corpo
// JSON; altrimenti rifiuta con un errore che porta `detail` (undefined se la risposta non ha un dettaglio leggibile).
export async function apiJson(url, { method = "GET", body } = {}) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  const headers = { Accept: "application/json", ...(token ? { "X-CSRF-Token": token } : {}) }
  if (body !== undefined && !(body instanceof FormData)) headers["Content-Type"] = "application/json"
  const res = await fetch(url, {
    method, credentials: "same-origin", headers,
    body: body === undefined ? undefined : body instanceof FormData ? body : JSON.stringify(body),
  })
  let data
  try { data = await res.json() } catch { data = undefined }
  if (!res.ok) {
    const errore = new Error(`HTTP ${res.status}`)
    errore.detail = data?.detail
    errore.status = res.status
    throw errore
  }
  return data
}
